import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';


const ViewMiqaats = () => {
  const [miqaatList, setMiqaatList] = useState([]);
  const [message,setMessage] = useState('')
  const {user,setUser} = useContext(UserContext)
  const navigate = useNavigate();

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])


  useEffect(() => {
    getMiqaat();
  }, []);

  const getMiqaat = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/miqaat/get?zoneId=${user.zone._id}`, { withCredentials: true });
      setMiqaatList(response.data.data);
      console.log(response.data.data);
    } catch (err) {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          } 
    }
  };

  const handleEditClick = (id) => {
    navigate(`/zc/edit-miqaat/${id}`);
  };

  const handleViewDetailsClick = (miqaatDetails) => {
    navigate("/zc/open-miqaat", { state: { miqaatDetails } });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
      {miqaatList.length === 0 ? (
        <div className="text-center text-gray-500">No Miqaats Added</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {miqaatList.map((miqaat) => (
            <div
              key={miqaat._id}
              className="bg-white p-4 flex justify-between items-center rounded-lg shadow hover:shadow-lg transition duration-300"
              onClick={() => handleViewDetailsClick(miqaat)}
            >
              <div>
                <h2 className="font-bold text-[17px] text-fmb mb-1">{miqaat.name}</h2>
                <p className="text-gray-500 text-sm mb-3">{new Date(miqaat.date).toDateString()}</p>
                <span className="text-xs font-semibold mr-2 px-3 py-1 rounded-full bg-green-100 text-gray-700">{miqaat.thaal} Thaal</span>
                <span className="text-xs font-semibold mr-2 px-3 py-1 rounded-full bg-green-100 text-gray-700">{miqaat.mumineenCount} Mumineen</span>
              </div>
              <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewMiqaats;
